export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id,
    depa_codigo: item.depa_codigo || "Código no disponible",  
    depa_descripcion: item.depa_descripcion || "Departamento disponible",  
    prov_descripcion: item.provincia?.pcia_descripcion || "Provincia no disponible",  
    mostrar: item.depa_show_web === 0 ? "Visible" : "Oculto"
  }));
